import { DEFAULT_LANGUAGE } from '@/constants/languages';

import packageJson from '../../package.json';

export type ENV_API = 'BASE_API' | 'INCIDENCE_API';

export const ENV = {
    API_SECRET: import.meta.env.VITE_API_SECRET as string,
    API_CLIENT_ID: import.meta.env.VITE_API_CLIENT_ID as string,
    API_URL: import.meta.env.VITE_API_URL as string,
    API_URL_MERCURE: import.meta.env.VITE_API_URL_MERCURE as string,
    API_URL_INCIDENTS: import.meta.env.VITE_API_URL_INCIDENTS as string,
    API_KEY_INCIDENTS: import.meta.env.VITE_API_KEY_INCIDENTS as string,

    APP_SECRET: import.meta.env.VITE_APP_SECRET as string,
    BASE_PATH: import.meta.env.VITE_BASE_PATH as string,
    LICENSE_MUI_XPRO: import.meta.env.VITE_LICENSE_MUI_XPRO as string,
    DEFAULT_SIDEBAR_WIDTH: (import.meta.env.VITE_DEFAULT_SIDEBAR_WIDTH as string) ?? '30',
    DEFAULT_ITEMS_PER_PAGE: (import.meta.env.VITE_DEFAULT_ITEMS_PER_PAGE as string) ?? '25',
    DEFAULT_APP_LOCALE: (import.meta.env.VITE_DEFAULT_APP_LOCALE as string) ?? DEFAULT_LANGUAGE,
    BROWSER_STORAGE_KEY: (import.meta.env.VITE_BROWSER_STORAGE_KEY as string) ?? 'ipglobal',
    MAPBOX_MAPS_API_KEY: (import.meta.env.VITE_MAPBOX_MAPS_API_KEY as string) ?? '',
    MAPBOX_MAPS_ZOOM: (import.meta.env.VITE_MAPBOX_MAPS_ZOOM as string) ?? 15,

    EVENT_CATEGORY_STANDARD_DB_ID:
        (import.meta.env.VITE_EVENT_CATEGORY_STANDARD_DB_ID as string) ?? '01869276-9803-7219-b1e5-c376ccd5fe86',

    EVENT_STATUS_INPROGRAMING_DB_ID:
        (import.meta.env.VITE_EVENT_STATUS_INPROGRAMING_DB_ID as string) ?? '018692e7-5e17-7239-bdc0-53dadae59f9d',
    EVENT_STATUS_PLANNED_DB_ID:
        (import.meta.env.VITE_EVENT_STATUS_PLANNED_DB_ID as string) ?? '018692e9-3dc9-72c6-ae8b-dfd9e83eb6a3',
    EVENT_STATUS_PUBLISHED_DB_ID:
        (import.meta.env.VITE_EVENT_STATUS_PUBLISHED_DB_ID as string) ?? '018692e9-7723-71ea-9992-88e7dab3a6ec',
    EVENT_STATUS_CANCELED_DB_ID:
        (import.meta.env.VITE_EVENT_STATUS_CANCELED_DB_ID as string) ?? '018692e9-a593-71c2-a27c-37f4059ccb35',
    EVENT_STATUS_COMPLETED_DB_ID:
        (import.meta.env.VITE_EVENT_STATUS_COMPLETED_DB_ID as string) ?? '018692e9-e7a4-71c7-b944-0bde80c6f2ba',

    NOTIFICATION_TYPE_SUBSCRIBER_IN_PARTICULAR_DB_ID:
        (import.meta.env.VITE_NOTIFICATION_TYPE_SUBSCRIBER_IN_PARTICULAR_DB_ID as string) ??
        '018a505d-32a3-70a6-80ba-517b3a6b0155',
    NOTIFICATION_TYPE_MULTIPLE_SUBSCRIBERS_DB_ID:
        (import.meta.env.VITE_NOTIFICATION_TYPE_MULTIPLE_SUBSCRIBERS_DB_ID as string) ??
        '018a6e8f-6b55-7227-9ffd-a8b9265ae9b0',
    NOTIFICATION_TYPE_ALL_SUBSCRIBERS_BY_EVENT_DB_ID:
        (import.meta.env.VITE_NOTIFICATION_TYPE_ALL_SUBSCRIBERS_BY_EVENT_DB_ID as string) ??
        'ab613c9c-0c5d-7ea9-4b08-3a6b54c7d141',
    NOTIFICATION_TYPE_ALL_SUBSCRIBERS_BY_SESSION_DB_ID:
        (import.meta.env.VITE_NOTIFICATION_TYPE_ALL_SUBSCRIBERS_BY_SESSION_DB_ID as string) ??
        'd1cacc20-1a5f-7bf9-7c03-4d9e97e6d70a',
    BY_ACTION_SOLD_OUT_TICKETS_DB_ID:
        (import.meta.env.VITE_BY_ACTION_SOLD_OUT_TICKETS_DB_ID as string) ?? 'efb2635f-a2a5-40a0-82d9-b8207bbd0c1c',

    INCIDENCE_STATUS_CREATED_ID:
        (import.meta.env.VITE_INCIDENCE_STATUS_CREATED_ID as string) ?? 'ec4032b7-5407-4977-80cf-97f1e0e6eb36',
    INCIDENCE_STATUS_IN_PROGRESS_ID:
        (import.meta.env.VITE_INCIDENCE_STATUS_IN_PROGRESS_ID as string) ?? '2b78d5d9-d1ec-40d3-82ba-6d6d66ad713f',
    INCIDENCE_STATUS_CLOSED_ID:
        (import.meta.env.VITE_INCIDENCE_STATUS_CLOSED_ID as string) ?? '41912f3d-c4db-4fb0-bd1e-74bbb6020cc9',
    INCIDENCE_STATUS_REOPENED_ID:
        (import.meta.env.VITE_INCIDENCE_STATUS_REOPENED_ID as string) ?? '376e061f-dcda-4f44-bdfb-6f8182d309e9',

    SENTRY_ENABLED: import.meta.env.VITE_SENTRY_ENABLED as string,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
    SENTRY_ENVIRONMENT: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string) || 'UNKNOWN',

    VERSION: packageJson.version as string,
};
